module.exports = __webpack_public_path__ + "img/lifeBlock_9_zh.fffad733.png";